import React from 'react';

interface LogoProps {
  linkPath?: string;
}

export default function Logo({ linkPath }: LogoProps) {
  return (
    <a href={linkPath}>
      <svg
        width="169"
        height="40"
        viewBox="0 0 1440 343"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7466_18270)">
          <path
            d="M412.458 336.048V0H459.63V119.433H460.537C480.948 91.7319 512.698 77.6543 546.717 77.6543C617.929 77.6543 676.894 137.598 676.894 210.257C676.894 282.916 621.557 342.405 550.799 342.405C514.513 342.405 480.948 327.874 460.083 299.718H459.176V336.048H412.458ZM629.722 210.257C629.722 162.574 592.075 120.796 543.542 120.796C495.009 120.796 458.269 161.666 458.269 209.349C458.269 257.031 495.916 299.264 543.995 299.264C592.075 299.264 629.722 259.302 629.722 210.257Z"
            fill="black"
          />
          <path d="M822.01 336.048V0H869.183V336.048H822.01Z" fill="black" />
          <path d="M932.259 84.4453H885.087V336.027H932.259V84.4453Z" fill="black" />
          <path
            d="M1123.69 336.018V198.875C1123.69 145.743 1102.82 120.766 1061.1 120.766C1019.37 120.766 994.873 151.192 994.873 198.421V336.018H947.701V84.4368H991.698V111.23H992.605C1011.2 87.1615 1037.06 77.625 1066.08 77.625C1126.41 77.625 1170.86 115.771 1170.86 185.251V336.018H1123.69Z"
            fill="black"
          />
          <path
            d="M1230.27 230.663C1241.16 272.442 1274.27 299.235 1312.82 299.235C1342.31 299.235 1369.98 283.795 1384.49 257.002H1431.66C1412.16 308.771 1364.99 342.376 1311.01 342.376C1240.25 342.376 1183.1 279.708 1183.1 212.498C1183.1 133.027 1242.97 77.625 1309.65 77.625C1383.58 77.625 1439.83 134.844 1439.83 207.049C1439.83 214.769 1439.83 222.035 1438.47 230.663H1230.27ZM1392.5 194.333C1388.87 151.646 1351.23 120.766 1310.86 120.766C1270.49 120.766 1233.75 151.192 1230.12 194.333H1392.5Z"
            fill="black"
          />
          <path
            d="M0 168.016C0 231.896 35.6815 287.449 88.1455 315.908V20.125C35.6815 48.5831 0 104.137 0 168.016Z"
            fill="#34A5AC"
          />
          <path
            d="M167.828 0C147.568 0 128.215 3.78432 110.223 10.4447V325.754C128.215 332.415 147.568 336.199 167.828 336.199C260.509 336.199 335.652 260.967 335.652 168.175C335.652 75.3837 260.509 0 167.828 0Z"
            fill="#34A5AC"
          />
          <path
            d="M688.417 181.172C690.685 194.19 691.441 210.235 689.324 228.4H807.859V181.172H688.417Z"
            fill="black"
          />
          <path
            d="M908.673 69.1736C921.7 69.1736 932.259 58.6012 932.259 45.5595C932.259 32.5177 921.7 21.9453 908.673 21.9453C895.647 21.9453 885.087 32.5177 885.087 45.5595C885.087 58.6012 895.647 69.1736 908.673 69.1736Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_7466_18270">
            <rect width="1439.66" height="342.405" fill="black" />
          </clipPath>
        </defs>
      </svg>
    </a>
  );
}
